import React, { FunctionComponent } from 'react';

import { SvgProps, propsHelperRem } from '@/shared/lib/propsHelper';

export const Fullscreen: FunctionComponent<SvgProps> = (props) => (
    <svg {...propsHelperRem(2.4, 2.4, props)}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.903 3.8H20.7v6.798h-2.4v-2.7l-3.996 3.996-1.697-1.697 3.996-3.996h-2.7V3.8ZM5.7 17.105l4.22-4.22 1.697 1.697-4.22 4.22h2.924v2.4H3.3V14.18h2.4v2.924Z"
            fill="#fff"
        />
    </svg>
);
